/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents a kind of payment plan for a pay-per-session agreement
 * in a Student.
 */
export enum PaymentPlanFrequency {
  NONE = "NONE",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
}
